import { useMemo } from 'react';
import type { ElasticListVehicle } from '@//app/api/search/vehicles';
import { type CfitImage, extractCacheBustingParam, urlToCfit } from '@//utils/image/urlToCfit';

const assetPrefix = process.env.NEXT_PUBLIC_ASSETS_CDN || '';

const fallbackImage: CfitImage = {
  src: `${assetPrefix}/images/placeholders/product-card.jpg`,
  srcSet: `${assetPrefix}/images/placeholders/product-card@2x.jpg 2x`,
  alt: 'Image missing',
  width: 450,
  height: 299,
};

const useProductCardContainerImage = (
  item: ElasticListVehicle,
  loading: React.ImgHTMLAttributes<HTMLImageElement>['loading'],
) => {
  const image = useMemo(() => {
    const url = item.featuredImage?.files?.[0]?.url;
    const r = extractCacheBustingParam(item.featuredImage?.files?.[0]?.formats);
    return url ? urlToCfit(url, { width: 450, alt: item.title, loading, r }) : fallbackImage;
  }, [item.featuredImage?.files, item.title]);
  return image;
};

export default useProductCardContainerImage;
